
export default class AddWarehouseCostPoolRequest {
    public warehouseId: string = "";
    
    public costPoolId: string = "";
}